var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    width: 160,
    height: 160,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 71,
    width: 175,
    height: 40,
    rx: 5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 125,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 221,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 317,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 365,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 125,
    width: 30,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 173,
    width: 30,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 221,
    width: 30,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 269,
    width: 30,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 317,
    width: 30,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 365,
    width: 30,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 413,
    width: 30,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 125,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 173,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 221,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 269,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 317,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 365,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 413,
    width: 120,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 125,
    width: 70,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 173,
    width: 70,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 221,
    width: 70,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 269,
    width: 70,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 317,
    width: 70,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 365,
    width: 70,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 413,
    width: 70,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 125,
    width: 116,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 173,
    width: 116,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 221,
    width: 116,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 269,
    width: 116,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 317,
    width: 116,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 365,
    width: 116,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 413,
    width: 116,
    height: 34,
    rx: 5,
    fill: "currentColor",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBudget);
export default __webpack_public_path__ + "static/media/card_budget.be240e512599fd46e07988a0e92a4c8e.svg";
export { ForwardRef as ReactComponent };